export const isTodaysDate = (date: Date) => {
  return date.setHours(0, 0, 0, 0) == new Date().setHours(0, 0, 0, 0);
};

export const areDatesEqual = (date1: Date, date2: Date) => {
  return date1 && date2 && date1.getTime() === date2.getTime();
};

export const getLastDateOfMonth = (year: number, month: number) => {
  return 32 - new Date(year, month, 32).getDate();
};

export const getLastDayOfMonth = (year: number, month: number) => {
  return new Date(year, month, getLastDateOfMonth(year, month)).getDay();
};

export const getMonthName = (month: number, format: 'long' | 'short' | 'narrow' = 'long') => {
  return new Date(2023, month, 1).toLocaleString('default', { month: format });
};

export const getPreviousMonth = (year: number, month: number): [year: number, month: number] => {
  if (month === 0) {
    year--;
    month = 11;
  } else {
    month--;
  }
  return [year, month];
};

export const getNextMonth = (year: number, month: number): [year: number, month: number] => {
  if (month === 11) {
    year++;
    month = 0;
  } else {
    month++;
  }
  return [year, month];
};

export const getLastDateOfPreviousMonth = (year: number, month: number) => {
  return getLastDateOfMonth(...getPreviousMonth(year, month));
};

export const getIsLeapYear = (year: number) => {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0;
};

export const formatISO = (date: Date | undefined) => {
  return date?.toISOString().split('T')[0] ?? '';
};

export const formatDate = (date: Date | undefined) => {
  return date?.toLocaleDateString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }) ?? '';
};

export const isValidDate = (date?: Date) => {
  return date !== undefined && !Number.isNaN(date.getTime());
};

export const getDaysToAppend = (year: number, month: number) => {
  const lastDateOfMonth = getLastDateOfMonth(year, month);
  const lastDayOfMonth = new Date(year, month, lastDateOfMonth).getDay();
  if (month === 1) {
    return lastDayOfMonth === 6 && !getIsLeapYear(year) ? 20 : 13;
  }

  const offset = lastDateOfMonth == 31 ? 2 : 1;
  return lastDayOfMonth < offset ? 6 : 13;
};

export const formatRange = (date1?: Date, date2?: Date) => {
  return date2 ? formatDate(date1) + ' - ' + formatDate(date2) : formatDate(date1);
};

export const splitRange = (range: string) => {
  if (!range) return [undefined, undefined];

  const spl = range.split(' - ');
  const startDate = verifyValidDate(spl[0]) ? new Date(spl[0]) : undefined;
  const endDate = verifyValidDate(spl[1]) ? new Date(spl[1]) : undefined;
  return [startDate, endDate];
};

export const isValidDateInput = (input: string) => {
  return /^(?:\d{1,2}\/){2}\d{2,4}$/.test(input) && verifyValidDate(input);
};

const verifyValidDate = (dateString: string) => {
  const dateObj = new Date(dateString);
  return (
    !Number.isNaN(dateObj.getTime()) &&
    // Compares the day in the input string with the day in the date object
    Number.parseInt(dateString.split('/')[1]) === dateObj.getDate()
  );
};

export const isValidDateRangeInputString = (input: string) => {
  return (
    /^(?:\d{1,2}\/){2}\d{4} - (?:\d{1,2}\/){2}\d{4}$/.test(input) &&
    // Verifies that neither date in the range is invalid
    input.split(' - ').filter((dateString: string) => !verifyValidDate(dateString)).length === 0
  );
};
